import { useBuscarTop10Dashboard } from "../../Scripts/Services/contabilidad-service.js";
import {Dropdown, MultiSelect} from 'primereact';
import React, {useEffect, useState} from 'react';

const Top10 = ({Top10, Tipo, ColorPrimario, MonedaPredeterminada, VisibleTables}) => {
  const formatearValores = (monto) => {
    return Citrus.Convert.toCurrencyNoSimbolo(monto);
  }
  return (
        <div className="card_row" style={{ marginTop: '50px' }}>
          {Object.keys(Top10)
            .map((key) => {
              const item = Top10[key];
              const titulo = Object.keys(item)[Object.keys(item).length - 1];
              if(VisibleTables.includes(titulo)){
                return (
                  <div className="wrapper" id={titulo} key={titulo}>
                    <div className="table">
                      <div
                        className="row_table"
                        style={{
                          borderRadius: '.25rem .25rem 0 0',
                          display: 'table-caption',
                          fontWeight: '900',
                          color: '#ffffff',
                          background: ColorPrimario,
                          textAlign: 'center',
                          padding: '5px',
                          fontSize: '18px',
                        }}
                      >
                        {titulo}
                      </div>
                      <div className="row_table header">
                        <div className="cell">
                          <span>#</span>
                        </div>
                        <div className="cell" style={{ width: '400px' }}>
                          Suplidor
                        </div>
                        <div className="cell" style={{ width: '300px', textAlign: 'right' }}>
                          {Tipo !== 'Cantidad' ? (
                            `${Tipo} (${MonedaPredeterminada})`
                          ) : (
                            `${Tipo}`
                          )}
                        </div>
                      </div>
                      {Object.keys(item).length < 2 ? (
                        <div className="row_table">
                          <div style={{ rowSpan: '3' }} className="cell">
                            No hay datos disponibles
                          </div>
                        </div>
                      ) : (
                        Object.keys(item).map((innerKey, index) => {
                          if (innerKey !== titulo) {
                            return (
                              <div className="row_table" key={index}>
                                <div className="cell" data-title="Posicion">
                                  {index + 1}
                                </div>
                                <div className="cell" data-title="Cliente" style={{ width: '400px' }}>
                                  {innerKey}
                                </div>
                                <div className="tipo cell" data-title={`${Tipo}`} style={{ width: '300px', textAlign: 'right' }}>
                                  {Tipo !== 'Cantidad' ? (
                                    formatearValores(item[innerKey])
                                  ) : (
                                    item[innerKey]
                                  )}
                                </div>
                              </div>
                            );
                          }
                          return null;
                        })
                      )}
                    </div>
                  </div>
                );
              }
            })}
        </div>
      );
}


export const FiltrosTop10 = () => {
    const moneda = window.monedaPredeterminada;
    const color = window.colorPrimario;
    const [where, setWhere] = React.useState({where: {periodo: 'Monto' }})
    const [tipo, setTipo] = React.useState(null);
    const [tipoDesc, setTipoDesc] = React.useState("Monto");
    const tipos = [
        {name: 'Monto', value: 1},
        {name: 'Cantidad', value: 2}
    ]
    const [documento, setDocumento] = React.useState(null);
    const documentos = [ 
        {name: 'Cuentas Contables (Transacciones)', value: 1},,
    ]

    const { data } = useBuscarTop10Dashboard(where);
    const [visibles, setVisibles] = React.useState([]);
    function handleTipoCambio(value){
        setTipo(value);
        var tipo;
        if(value == 1) tipo = "Monto"
        else tipo = "Cantidad"
        setTipoDesc(tipo);
        setWhere({where: {periodo: tipo}});
    }

    function handleDocumentoCambio(value){
        setDocumento(value);
        const tablas = getNamesByValues(value);
        setVisibles(tablas);
    }

    function getNamesByValues(values) {
        return values.map(value => {
          const tipo = documentos.find(t => t.value === value);
          return tipo ? tipo.name : null;
        });
      }
    return (
        <React.Fragment>
        <div style={{ display: 'flex', marginTop:'30px'}}>
            <div className="card flex justify-content-center" style={{marginRight: '5px'}}>
                <span className="p-float-label">
                    <Dropdown inputId="dd-city" value={tipo} onChange={(e) => handleTipoCambio(e.value)} options={tipos} optionLabel="name"/>
                    <label htmlFor="dd-city">Tipo</label>
                </span>
            </div>
            <div className="card flex justify-content-center" style={{display: 'flex', justifyContent:'center', alignItems:'center'}}>
                <span className="p-float-label" style={{ minWidth: '150px'}}>       
                    <MultiSelect 
                    value={documento} 
                    onChange={(e) => handleDocumentoCambio(e.value)} 
                    options={documentos} 
                    optionLabel="name" 
                    display="chip" 
                    selectAllLabel="Seleccionar todos"

                    />
                    <label htmlFor="ms-cities">Tipos Documento</label>
                </span>
            </div>
        </div>
        {data && (        
        <Top10 key={visibles} Top10={data.Top10} Tipo={tipoDesc} MonedaPredeterminada={moneda} ColorPrimario={color} VisibleTables={visibles} />
        )}

        </React.Fragment>
    );
}